export const isolateError = async <T>(
  asyncFunction: Promise<T>,
): Promise<[(T | undefined)?, unknown?]> => {
  try {
    const done = await asyncFunction;
    return [done, undefined];
  } catch (err: unknown) {
    return [undefined, err];
  }
};
